/* eslint-disable */
export default {
  copyToClipboard: 'Copia negli Appunti',
} as const;

// @key: @#@"copyToClipboard"@#@ @source: @#@"Copy to Clipboard"@#@
